module.exports = __webpack_public_path__ + "static/media/triangulo.62b23b5e.svg";